const announcementContext = require.context(
  "../images/announcements",
  false,
  /\.(png|jpe?g|svg)$/
);

function filenameFromKey(key) {
  return key.replace(/^\.\//, "").replace(/\.[^.]+$/, "");
}

/** @returns {{ key: string, src: string, label: string }[]} newest first (by filename) */
function getAnnouncementImages() {
  return announcementContext
    .keys()
    .sort()
    .reverse()
    .map((key) => ({
      key,
      src: announcementContext(key),
      label: filenameFromKey(key),
    }));
}

function getLatestAnnouncementImage() {
  const keys = announcementContext.keys().sort();
  const last = keys[keys.length - 1];
  return last ? announcementContext(last) : null;
}

export { getAnnouncementImages, getLatestAnnouncementImage };
